export const mapInputsToAddressBG = (addressFormInputs) => {
	const {
		quarter,
		street,
		streetNumber,
		businessOrComplexName,
		building,
		entrance,
		floor,
		apartment,
	} = addressFormInputs;

	const parts = [
		quarter || null,
		street ? `ул. ${street}` : null,
		streetNumber ? `№${streetNumber}` : null,
		building ? `бл. ${building}` : null,
		businessOrComplexName || null,
		entrance ? `вх. ${entrance}` : null,
		floor ? `ет. ${floor}` : null,
		apartment ? `ап. ${apartment}` : null,
	];

	return parts.filter(Boolean).join(', ');
};
